import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { apiPost } from '../../utils/apiUtils';

export const ProfileSummary: React.FC = () => {
  const { user } = useAuth();
  const [summary, setSummary] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      if (!user?.id) return;

      try {
        setLoading(true);
        const data = await apiPost('/api/get-user-preferences', {
          userData: {
            sub: user.id,
            email: user.email,
          },
        });

        if (data.success && data.preferences?.summary) {
          setSummary(data.preferences.summary);
        }
      } catch (error) {
        console.error('[ProfileSummary] Error fetching summary:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, [user]);

  return (
    <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex items-start gap-3 md:gap-4">
        {/* Icon */}
        <div className="w-9 h-9 md:w-10 md:h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
          <svg
            className="w-4 h-4 md:w-5 md:h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <h2 className="text-base md:text-lg font-semibold text-gray-800 mb-2 md:mb-2.5">Profile Summary</h2>
          {loading ? (
            <div className="space-y-2">
              <div className="h-3 md:h-4 bg-gray-100 rounded animate-pulse w-full"></div>
              <div className="h-3 md:h-4 bg-gray-100 rounded animate-pulse w-5/6"></div>
              <div className="h-3 md:h-4 bg-gray-100 rounded animate-pulse w-4/6"></div>
            </div>
          ) : summary ? (
            <p className="text-gray-600 leading-relaxed text-xs md:text-[15px]">
              {summary}
            </p>
          ) : (
            <div className="flex flex-col items-center justify-center py-6 md:py-8">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gray-50 rounded-full flex items-center justify-center mb-3 md:mb-4">
                <svg
                  className="w-6 h-6 md:w-8 md:h-8 text-gray-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <p className="text-gray-500 text-xs md:text-sm text-center">
                Upload a CV to generate your profile summary
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

